import React, { Component } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import { addProductStore } from "../../stores"
import { AppHeader, AppPanel, Icon } from "../../lib"
import ProductSelector from "./ProductSelector"
import ProductDesigner from "./ProductDesigner"
import ProductEditor from "./ProductEditor"
import ProductNav from "./ProductNav"
import {
  PRODUCT_SELECT_STEP,
  PRODUCT_DESIGN_STEP,
  PRODUCT_EDITOR_STEP
} from "./constants"

class AddProduct extends Component {
  componentWillMount() {
    addProductStore.reset()
  }

  render() {
    const { step } = addProductStore
    return (
      <div>
        <AppHeader>
          <Link to="/products">
            <Icon name="back" color="white" size={12} /> Back to products
          </Link>
          <h1>Add a product</h1>
        </AppHeader>
        <AppPanel>
          <ProductNav />
          {step === PRODUCT_SELECT_STEP && <ProductSelector />}
          {step === PRODUCT_DESIGN_STEP && <ProductDesigner />}
          {step === PRODUCT_EDITOR_STEP && <ProductEditor />}
        </AppPanel>
      </div>
    )
  }
}

AddProduct.displayName = "AddProduct"

export default observer(AddProduct)



// WEBPACK FOOTER //
// ./src/products/add/AddProduct.js